import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { getActiveListingPage } from '../../reduck/selectors';
import LocationBlock from '../LocationSearch/LocationBlock';

const Article = styled.article`
    position: relative;
    margin: auto;
    box-sizing: border-box;
    display: block;
    font-family: Helvetica, Arial, Sans-serif;
    font-size: 14px;

    @media ${({ theme }) => theme.breakpoints.desktop} { 
      margin-left: 2%;
    }
`;

const LocationSearchBlockWrapper = ({
  name,
  locationSearchInitialized,
  groupcallLoading,
  noProductsOnListingPage
}) =>
  (locationSearchInitialized && !groupcallLoading && !noProductsOnListingPage
    ? (name === 'above product listing' && (
    <Article data-component={'locationsearch'}>
      <LocationBlock name={name} />
    </Article>
    )) ||
      (name === 'filter block' && <LocationBlock name={name} />)
    : null);

LocationSearchBlockWrapper.propTypes = {
  // DON'T CHANGE THE VALUES of the following prop, the format is due to analytics
  name: PropTypes.oneOf(['above product listing', 'filter block']).isRequired,
  locationSearchInitialized: PropTypes.bool.isRequired,
  groupcallLoading: PropTypes.bool.isRequired,
  noProductsOnListingPage: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  locationSearchInitialized: state.listingPage.locationSearchSetup.locationSearchInitialized,
  groupcallLoading: !state.configuration.groupcallLoaded,
  noProductsOnListingPage: getActiveListingPage(state).productList.length === 0
});

export default connect(mapStateToProps)(LocationSearchBlockWrapper);
